<template>
  <div id="app" :class="[this.pagesClasses, {'screentest': this.$route.query.screentest, 'isIE': this.isIE, 'on_ie': this.isIE}]">
    <brand-top></brand-top>
    <div :class="['site__wrapper']" :style="this.wrapperPadding">
      <main-menu v-if="this.userAgent.window.width < 1024 && this.$route.name !== 'Home'"></main-menu>
      <logo class="logo-app"></logo>
      <div class="content_wrapper">
        <div class="isi-header_box">
          <a title :href="this.urls.PI" class="isi-header_box-link" target="_blank">Prescribing information</a>
          <a title :href="this.urls.MG" class="isi-header_box-link" target="_blank">Medication Guide</a>
        </div>
        <sweet-modal ref="modal-video" modal-theme="light" overlay-theme="light">
          <div class="flexible-container video-modal__video">
            <div v-show="this.$route.meta.id === 1" class="wistia_embed wistia_async_b7vz0c7xf5 videoFoam=true" style="height:100%;width:100%">&nbsp;</div>
            <div v-show="this.$route.meta.id === 2" class="wistia_embed wistia_async_ffw8govilj videoFoam=true" style="height:100%;width:100%">&nbsp;</div>
            <div v-show="this.$route.meta.id === 3" class="wistia_embed wistia_async_qqkndi7u6m videoFoam=true" style="height:100%;width:100%">&nbsp;</div>
          </div>
        </sweet-modal>
        <transition-wrapper>
          <router-view/>
        </transition-wrapper>
        <sidebar-navigation v-show="this.$route.name !== 'Home'"></sidebar-navigation>
      </div>
      <important-safety-information></important-safety-information>
    </div>
    <brand-footer></brand-footer>
    <!-- <unsupported-devices v-if="!this.$route.query.screentest"></unsupported-devices> -->
    <rotate-lock v-if="this.userAgent.orientation === 'landscape' && this.userAgent.window.width < 1113 && !this.videoState"></rotate-lock>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
/* COMPONENTS */
import TransitionWrapper from '@/TransitionWrapper';
import ISI from '@/components/ISI/ISI';
import BrandTop from '@/components/Brand/BrandTop';
import BrandFooter from '@/components/Brand/BrandFooter';
import Logo from '@/components/Logo/Logo.vue';
import MainMenu from '@/components/Patients/blocks/Menu/Menu.vue';
import SideNav from '@/components/Patients/blocks/SideNav/SideNav';
/* COMMON-COMPONENTS */
// import UnsupportedDevices from '@/components/common/UnsupportedDevices/UnsupportedDevices';
import rotateLock from '@/components/common/rotate-lock/rotate-lock';
/* MIXINS */
import lockScroll from '@/mixins/lock-scroll';
import handleResize from '@/mixins/handleResize';
import handleOrientation from '@/mixins/handleOrientation';
import fixSafariOffset from '@/mixins/fixSafariOffset';
import { SweetModal } from 'sweet-modal-vue';

Vue.mixin(lockScroll);

export default {
  name: 'App',
  data() {
    return {
      to: '',
      from: '',
      scrollTop: 0
    };
  },
  components: {
    'brand-top': BrandTop,
    'brand-footer': BrandFooter,
    'important-safety-information': ISI,
    // 'unsupported-devices': UnsupportedDevices,
    'rotate-lock': rotateLock,
    'transition-wrapper': TransitionWrapper,
    'logo': Logo,
    'main-menu': MainMenu,
    'sidebar-navigation': SideNav,
    'sweet-modal': SweetModal
  },
  mixins: [handleOrientation, fixSafariOffset, handleResize],
  computed: {
    ...mapState([
      'videoState'
    ]),
    wrapperPadding() {
      if (this.isiStatus) return true;
      if (this.userAgent.window.width < 1024 && this.isiState !== 2) {
        return { 'padding-bottom': parseInt(this.isiHeight) + 'px' } // default mobile
      } else if (this.userAgent.window.width <= 1024 && this.isiState !== 2 && this.userAgent.orientation === 'landscape') {
        return { 'padding-bottom': parseInt(this.isiHeight) + 'px' } // default mobile
      } else if (this.userAgent.window.width <= 1024 && this.isiState === 2 && this.userAgent.orientation === 'landscape') {
        return { 'padding-bottom': '120px' } // less mobile
      } else if (this.userAgent.window.width >= 1024 && this.isiState !== 2) {
        return { 'padding-bottom': parseInt(this.isiHeight) + 50 + 'px' } // default desktop
      } else if (this.userAgent.window.width >= 1024 && this.isiState === 2) {
        return { 'padding-bottom': '140px' } // less desktop
      } else {
        return { 'padding-bottom': '120px' } // less mobile
      }
    },
    isIE() {
      return this.userAgent.browser.name === 'ie';
    },
    pagesClasses() {
      if (this.$route.name === 'Home') {
        return 'homescreen'
      } else {
        var patient = 'patient_' + this.$route.name.toString().toLowerCase();
        return patient;
      }
    },
    ...mapState(['userAgent', 'isiHeight', 'isiStatus', 'currentPage', 'isiState', 'urls', 'poll_info'])
  },
  methods: {
    currentRoute(to) {
      if (to.name === 'Susan') {
        this.data = {
          isHomePage: false,
          isSusan: true,
          isJoseph: false,
          isGabrielle: false,
        };
        this.$store.commit('SET_INACTIVE_ROUTE', 0);
        this.$store.commit('SET_ACTIVE_ROUTE', 1);
        this.$store.commit('SET_ACTIVE_ROUTE', 2);
        this.$store.commit('SET_PAGE_INFO', this.data);
      }
      if (to.name === 'Joseph') {
        this.data = {
          isHomePage: false,
          isSusan: false,
          isJoseph: true,
          isGabrielle: false,
        };
        this.$store.commit('SET_INACTIVE_ROUTE', 1);
        this.$store.commit('SET_ACTIVE_ROUTE', 0);
        this.$store.commit('SET_ACTIVE_ROUTE', 2);
        this.$store.commit('SET_PAGE_INFO', this.data);
      }
      if (to.name === 'Gabrielle') {
        this.data = {
          isHomePage: false,
          isSusan: false,
          isJoseph: false,
          isGabrielle: true,
        };
        this.$store.commit('SET_INACTIVE_ROUTE', 2);
        this.$store.commit('SET_ACTIVE_ROUTE', 0);
        this.$store.commit('SET_ACTIVE_ROUTE', 1);
        this.$store.commit('SET_PAGE_INFO', this.data);
      }
      if (to.name === 'Home') {
        this.data = {
          isHomePage: true,
          isSusan: false,
          isJoseph: false,
          isGabrielle: false
        };
        this.$store.commit('SET_PAGE_INFO', this.data);
      }
    },
    getScrollTop() {
      if( !this.isiStatus ) {
        this.scrollTop = document.documentElement.scrollTop;
      }
    },
    isIpadOS() {
      return navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform);
    }
  },
  beforeMount() {
    this.$store.dispatch('setInitialAnswer', true);
    this.currentRoute(this.$route);
  },
  created() {
  },
  mounted() {
    window.addEventListener('scroll', this.getScrollTop);
    if (localStorage.getItem('quizData_alk_odactra_pj')) {
      this.$store.commit('UPDATE_QUIZ_DATA', JSON.parse(localStorage.getItem('quizData_alk_odactra_pj')));
    }
  },
  destroyed() {
  },
  watch: {
    $route(to, from) {
      this.to = to;
      this.from = from;
      this.currentRoute(to);
    },
    isiStatus(oldVal, newVal) {
      if (newVal) {
        setTimeout(() => {
          window.scrollTo(0, this.scrollTop);
          console.log(this.scrollTop);
        }, 100);
      }
    }
  }
};
</script>

<style lang="scss" src="./styles/main.scss"></style>
